import React, { type ReactNode } from 'react';
import { StandardButton } from '../../buttons/index.js';

interface IInfiniteList {
  load: () => void;
  hasMore: boolean;
  children?: ReactNode;
  endMessage?: ReactNode;
}
export const InfiniteList = ({ load, hasMore, children, endMessage }: IInfiniteList) => {
  return (
    <>
      {children}
      {!hasMore && endMessage}
      {hasMore && <StandardButton type="loadMore" showDefaultText onClick={() => load()} />}
    </>
  );
};
